export default "__VITE_ASSET__yD2SGum4__"